/**
 * @generated SignedSource<<3c074da8d0a51a2adc6591d8461b1a34>>
 * @relayHash 0335332109c787dc4b91ad6ee3894ceb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 43e7393e2b1dd4daa4f22d1c50da6e90c43cb68701111912458e4f4d7d7f6af0

import type { ConcreteRequest, Query } from 'relay-runtime';
export type AppNetworkEgressCategoryExtension = "ANALYTICS" | "%future added value";
export type AppNetworkPermissionTypeExtension = "FETCH_BACKEND_SIDE" | "FETCH_CLIENT_SIDE" | "FONTS" | "FRAMES" | "IMAGES" | "MEDIA" | "NAVIGATION" | "SCRIPTS" | "STYLES" | "%future added value";
export type CapabilitySet = "capabilityAdvanced" | "capabilityStandard" | "%future added value";
export type DataClassificationPolicyDecisionStatus = "ALLOWED" | "BLOCKED" | "%future added value";
export type EcosystemLicenseMode = "USER_ACCESS" | "%future added value";
export type ExtensionContextsFilterType = "APP_ID_ENVIRONMENT_ID" | "DATA_CLASSIFICATION_TAG" | "DEFINITION_ID" | "EXTENSION_TYPE" | "PRINCIPAL_TYPE" | "%future added value";
export type ExtensionContextsFilter = {
  type: ExtensionContextsFilterType;
  value: ReadonlyArray<string>;
};
export type useExtensionList_forge_ui_Query$variables = {
  contextIds: ReadonlyArray<string>;
  dataClassificationTags: ReadonlyArray<string>;
  filter: ReadonlyArray<ExtensionContextsFilter>;
  locale?: string | null | undefined;
};
export type useExtensionList_forge_ui_Query$data = {
  readonly extensionContexts: ReadonlyArray<{
    readonly extensions: ReadonlyArray<{
      readonly appId: string;
      readonly appOwner: {
        readonly name: string;
      } | null | undefined;
      readonly appVersion: string | null | undefined;
      readonly consentUrl: string | null | undefined;
      readonly currentUserConsent: {
        readonly appEnvironmentVersion: {
          readonly id: string;
        };
        readonly consentedAt: AGG$DateTime;
        readonly user: {
          readonly aaid: string;
        };
      } | null | undefined;
      readonly dataClassificationPolicyDecision: {
        readonly status: DataClassificationPolicyDecisionStatus;
      };
      readonly egress: ReadonlyArray<{
        readonly addresses: ReadonlyArray<string> | null | undefined;
        readonly category: AppNetworkEgressCategoryExtension | null | undefined;
        readonly inScopeEUD: boolean | null | undefined;
        readonly type: AppNetworkPermissionTypeExtension | null | undefined;
      }> | null | undefined;
      readonly environmentId: string;
      readonly environmentKey: string;
      readonly environmentType: string;
      readonly id: string;
      readonly installationConfig: ReadonlyArray<{
        readonly key: string;
        readonly value: boolean;
      }> | null | undefined;
      readonly installationId: string;
      readonly key: string;
      readonly license: {
        readonly active: boolean;
        readonly billingPeriod: string | null | undefined;
        readonly capabilitySet: CapabilitySet | null | undefined;
        readonly ccpEntitlementId: string | null | undefined;
        readonly ccpEntitlementSlug: string | null | undefined;
        readonly isEvaluation: boolean | null | undefined;
        readonly modes: ReadonlyArray<EcosystemLicenseMode> | null | undefined;
        readonly subscriptionEndDate: AGG$DateTime | null | undefined;
        readonly supportEntitlementNumber: string | null | undefined;
        readonly trialEndDate: AGG$DateTime | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
      readonly migrationKey: string | null | undefined;
      readonly properties: AGG$JSON;
      readonly requiresUserConsent: boolean | null | undefined;
      readonly scopes: ReadonlyArray<string>;
      readonly type: string;
      readonly userAccess: {
        readonly enabled: boolean;
        readonly hasAccess: boolean;
      } | null | undefined;
    }>;
    readonly id: string;
  }> | null | undefined;
};
export type useExtensionList_forge_ui_Query = {
  response: useExtensionList_forge_ui_Query$data;
  variables: useExtensionList_forge_ui_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contextIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dataClassificationTags"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v4 = [
  {
    "kind": "Variable",
    "name": "contextIds",
    "variableName": "contextIds"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "locale",
    "variableName": "locale"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "appId"
},
v8 = {
  "kind": "ScalarField",
  "name": "key"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "environmentId"
},
v11 = {
  "kind": "ScalarField",
  "name": "environmentType"
},
v12 = {
  "kind": "ScalarField",
  "name": "environmentKey"
},
v13 = {
  "kind": "ScalarField",
  "name": "properties"
},
v14 = {
  "kind": "ScalarField",
  "name": "type"
},
v15 = {
  "concreteType": "AppInstallationLicense",
  "kind": "LinkedField",
  "name": "license",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "active"
    },
    (v14/*: any*/),
    {
      "kind": "ScalarField",
      "name": "supportEntitlementNumber"
    },
    {
      "kind": "ScalarField",
      "name": "trialEndDate"
    },
    {
      "kind": "ScalarField",
      "name": "subscriptionEndDate"
    },
    {
      "kind": "ScalarField",
      "name": "isEvaluation"
    },
    {
      "kind": "ScalarField",
      "name": "billingPeriod"
    },
    {
      "kind": "ScalarField",
      "name": "ccpEntitlementId"
    },
    {
      "kind": "ScalarField",
      "name": "ccpEntitlementSlug"
    },
    {
      "kind": "ScalarField",
      "name": "capabilitySet"
    },
    {
      "kind": "ScalarField",
      "name": "modes"
    }
  ]
},
v16 = {
  "concreteType": "UserAccess",
  "kind": "LinkedField",
  "name": "userAccess",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "enabled"
    },
    {
      "kind": "ScalarField",
      "name": "hasAccess"
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "appVersion"
},
v18 = {
  "kind": "ScalarField",
  "name": "installationId"
},
v19 = {
  "kind": "ScalarField",
  "name": "migrationKey"
},
v20 = {
  "concreteType": "EcosystemAppInstallationConfigExtension",
  "kind": "LinkedField",
  "name": "installationConfig",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ]
},
v21 = {
  "concreteType": "AppNetworkEgressPermissionExtension",
  "kind": "LinkedField",
  "name": "egress",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    {
      "kind": "ScalarField",
      "name": "addresses"
    },
    {
      "kind": "ScalarField",
      "name": "category"
    },
    {
      "kind": "ScalarField",
      "name": "inScopeEUD"
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "scopes"
},
v23 = {
  "kind": "ScalarField",
  "name": "consentUrl"
},
v24 = {
  "concreteType": "UserConsentExtension",
  "kind": "LinkedField",
  "name": "currentUserConsent",
  "plural": false,
  "selections": [
    {
      "concreteType": "UserConsentExtensionUser",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "aaid"
        }
      ]
    },
    {
      "concreteType": "UserConsentExtensionAppEnvironmentVersion",
      "kind": "LinkedField",
      "name": "appEnvironmentVersion",
      "plural": false,
      "selections": [
        (v5/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "consentedAt"
    }
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "requiresUserConsent"
},
v26 = {
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "dataClassificationTags",
          "variableName": "dataClassificationTags"
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ],
  "concreteType": "DataClassificationPolicyDecision",
  "kind": "LinkedField",
  "name": "dataClassificationPolicyDecision",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useExtensionList_forge_ui_Query",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "ExtensionContext",
        "kind": "LinkedField",
        "name": "extensionContexts",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "args": (v6/*: any*/),
            "concreteType": "Extension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "name": "appOwner",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ]
              },
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v14/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useExtensionList_forge_ui_Query",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "ExtensionContext",
        "kind": "LinkedField",
        "name": "extensionContexts",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "args": (v6/*: any*/),
            "concreteType": "Extension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "name": "appOwner",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v9/*: any*/),
                  (v5/*: any*/)
                ]
              },
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v14/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "43e7393e2b1dd4daa4f22d1c50da6e90c43cb68701111912458e4f4d7d7f6af0",
    "metadata": {},
    "name": "useExtensionList_forge_ui_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f4550c57b587a03d152e887674cfab78";

export default node;
